import { render, staticRenderFns } from "./Afterserviceedit.vue?vue&type=template&id=136ef412&scoped=true&"
import script from "./Afterserviceedit.vue?vue&type=script&lang=js&"
export * from "./Afterserviceedit.vue?vue&type=script&lang=js&"
import style0 from "./Afterserviceedit.vue?vue&type=style&index=0&id=136ef412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ef412",
  null
  
)

export default component.exports